import { render } from "./page-content.vue?vue&type=template&id=2cddee80&scoped=true&ts=true"
import script from "./page-content.vue?vue&type=script&lang=ts"
export * from "./page-content.vue?vue&type=script&lang=ts"

import "./page-content.vue?vue&type=style&index=0&id=2cddee80&scoped=true&lang=css"

import exportComponent from "E:\\项目对接\\parent-reporting-backend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cddee80"]])

export default __exports__